import React from 'react';
import { Button, Modal, Form, Input, Select, message } from 'antd';
import { api, onPost, onGet } from '../../../../core/api3';

const Option = Select.Option;

class HuobiInvestmentEditView extends React.Component {

    constructor() {
        super();
        this.state = {
            symbols: [],
            investment: {}
        }
        this.loadData = this.loadData.bind(this);
        this.onClick = this.onClick.bind(this);
    }

    componentDidMount() {
        onGet(api.listHuobiInvestmentSymbol.url).then(response => {
            if (response === undefined) {
                return;
            }
            this.setState({ symbols: response });
        });
        this.loadData();
    }

    loadData() {
        if (!this.props.isAdd) {
            onGet(api.getHuobiInvestment.url, api.getHuobiInvestment.params(this.props.investmentId)).then(response => {
                if (response === undefined) {
                    return;
                }
                this.setState({ investment: response });
            });
        }
    }

    onClick(type) {
        switch (type) {
            case 'confirm':
                this.props.form.validateFieldsAndScroll((error, fields) => {
                    if (error) {
                        return;
                    }
                    if (this.props.isAdd) {
                        onPost(api.addHuobiInvestment.url,
                            api.addHuobiInvestment.params(fields.symbol, fields.type, fields.price, fields.volume, fields.commission, fields.totalPrice)).then(response => {
                                if (response === undefined) {
                                    return;
                                }
                                message.success('添加成功');
                                this.props.onModalFinish();
                            });
                    } else {
                        onPost(api.updateHuobiInvestment.url, api.updateHuobiInvestment.params(this.state.investment.id, fields.price, fields.volume, fields.commission, fields.totalPrice)).then(response => {
                            if (response === undefined) {
                                return;
                            }
                            message.success('更新成功');
                            this.props.onModalFinish();
                        });
                    }
                });
                break;
            default:
                break;
        }
    }

    render() {
        let symbols = [];
        this.state.symbols.forEach(symbol => {
            symbols.push(<Option key={symbol.symbol}>{symbol.symbol}</Option>);
        });
        const formItemLayout = {
            labelCol: { span: 4 },
            wrapperCol: { span: 20 }
        };
        return (
            <Modal title={this.props.isAdd ? '添加' : '编辑'} visible={true} okButtonProps={{ hidden: true }} cancelButtonProps={{ hidden: true }} onCancel={this.props.onModalCancel}>
                <Form>
                    <Form.Item {...formItemLayout} label="定投币种">
                        {this.props.form.getFieldDecorator('symbol', {
                            initialValue: this.state.investment.symbol === undefined ? undefined : this.state.investment.symbol + '',
                            rules: [{ required: true, message: '请选择定投币种' }]
                        })(
                            <Select placeholder="请选择定投币种">
                                {symbols}
                            </Select>
                        )}
                    </Form.Item>
                    <Form.Item {...formItemLayout} label="定投方向">
                        {this.props.form.getFieldDecorator('type', {
                            initialValue: this.state.investment.type === undefined ? undefined : this.state.investment.type + '',
                            rules: [{ required: true, message: '请选择定投方向' }]
                        })(
                            <Select placeholder="请选择定投方向">
                                <Option key="1">买入</Option>
                                <Option key="2">卖出</Option>
                            </Select>
                        )}
                    </Form.Item>
                    <Form.Item {...formItemLayout} label="币种单价">
                        {this.props.form.getFieldDecorator('price', {
                            initialValue: this.state.investment.price,
                            rules: [{ required: true, message: '请输入币种单价' }, { pattern: /^[0-9]*(\.)?[0-9]*$/, message: '请输入整数或小数' }]
                        })(
                            <Input placeholder="请输入币种单价" maxLength="20" addonAfter="USDT" />
                        )}
                    </Form.Item>
                    <Form.Item {...formItemLayout} label="币种数量">
                        {this.props.form.getFieldDecorator('volume', {
                            initialValue: this.state.investment.volume,
                            rules: [{ required: true, message: '请输入币种数量' }, { pattern: /^[0-9]*(\.)?[0-9]*$/, message: '请输入整数或小数' }]
                        })(
                            <Input placeholder="请输入币种数量" maxLength="20" />
                        )}
                    </Form.Item>
                    <Form.Item {...formItemLayout} label="手续费">
                        {this.props.form.getFieldDecorator('commission', {
                            initialValue: this.state.investment.commission,
                            rules: [{ required: true, message: '请输入手续费' }, { pattern: /^[0-9]*(\.)?[0-9]*$/, message: '请输入整数或小数' }]
                        })(
                            <Input placeholder="请输入手续费" maxLength="20" />
                        )}
                    </Form.Item>
                    <Form.Item {...formItemLayout} label="定投金额">
                        {this.props.form.getFieldDecorator('totalPrice', {
                            initialValue: this.state.investment.totalPrice === undefined ? undefined : this.state.investment.totalPrice + '',
                            rules: [{ required: true, message: '请输入定投金额' }, { pattern: /^[0-9]*$/, message: '请输入纯数字' }]
                        })(
                            <Input placeholder="请输入定投金额" maxLength="20" addonAfter="元" />
                        )}
                    </Form.Item>
                    <Form.Item wrapperCol={{ span: 20, offset: 4 }}>
                        <Button type="primary" onClick={() => this.onClick('confirm')} hidden={this.props.isAdd}>确定</Button>
                        <Button type="primary" onClick={() => this.onClick('confirm')} hidden={!this.props.isAdd}>添加</Button>
                    </Form.Item>
                </Form>
            </Modal>
        );
    }


}

const HuobiInvestmentEditModal = Form.create()(HuobiInvestmentEditView);
export default HuobiInvestmentEditModal;


// WEBPACK FOOTER //
// ./src/page/jsx/coin/huobi/HuobiInvestmentEditModal.jsx